import { WidgetIntegrationPayload } from "@src/models";
import { createTxWidgetWC, TxWidgetWCAttributes } from "./TxWidgetWC";
import { isServer } from "@tanstack/react-query";

const TxWidgetWC = createTxWidgetWC();

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      "swapper-sdk-widget": React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > &
        TxWidgetWCAttributes;
    }
  }
}

if (!isServer && typeof customElements !== "undefined") {
  if (!customElements.get("swapper-sdk-widget")) {
    customElements.define("swapper-sdk-widget", TxWidgetWC);
  }
}

export const TxWidgetWCWrapped = ({
  integratorId,
  integrationType,
  chainIds,
  dstChainId,
  dstToken,
  dstTokenImage,
  customContractCalls = [],
  externalWalletAddress,
  desc,
  defaultWalletPicker,
  development = false,
  cta,
  styles,
}: WidgetIntegrationPayload) => {
  return (
    <swapper-sdk-widget
      integrator-id={integratorId}
      integration-type={integrationType}
      chain-ids={chainIds ? JSON.stringify(chainIds) : ""}
      dst-chain-id={dstChainId}
      dst-token={dstToken}
      dst-token-image={dstTokenImage}
      custom-contract-calls={customContractCalls}
      external-wallet-address={externalWalletAddress}
      desc={desc}
      default-wallet-picker={defaultWalletPicker}
      development={development}
      cta={cta ? JSON.stringify(cta) : undefined}
      styles={styles ? JSON.stringify(styles) : undefined}
    ></swapper-sdk-widget>
  );
};
